<template>
  <div>
    <button class="btn btn-sm btn-info " :disabled="disabled"
      @click="downloadItem({url, name: name})">
      <slot></slot>
    </button>
  </div>
</template>
<script>
  import { errorNotify } from "@/plugins/functions";
  export default{
    props: {
      disabled: {
        default: false
      },
      name: {
        default: "",
      },
      url: {
        default: "",
      },
      params:{
        default: function(){
          return {};
        }
      },
    },
    // props:["url", "name", "params"],
    data(){
      return {

      }
    },
    mounted(){
      console.log(this.params)
    },
    methods:{
      async downloadItem({ url, name }) {
        this.disabled = true
        let params = {}
        if(this.params)
          params = this.params
        await this.$http
          .get(url, { 
            responseType: 'blob', 
            params 
          })
          .then((response) => {
            const blob = new Blob([response.data], { type: response.data.type });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = name;
            link.click();
            URL.revokeObjectURL(link.href);
            setTimeout(() => {
              this.disabled = false  
            }, 1000);
            
          })
          .catch((error) => {
            error.response.data.text().then(e=>{
              if(e)
                errorNotify({
                  response: {data: JSON.parse(e)}
                }, this.$notify);
            })
          }).finally(() => {
            // setTimeout(() => {
            //   this.loading = false;
            // }, 400);
          });
      },
    }
  }
</script>